<template>
  <v-list
    :class="['py-0 gap-4', isMiniSidebarShown ? 'd-flex flex-column align-center' : 'custom-grid']"
    flat
  >
    <v-tooltip v-for="(item, key) in supportMenu" :key="key" location="end" color="secondary-800">
      <template #activator="{ props: tooltipProps }">
        <v-hover v-slot="{ isHovering, props: hoverProps }">
          <v-list-item
            :href="item.url"
            :target="item.isButton ? null : '_blank'"
            :class="[
              'min-height-auto flex-unset rounded-lg py-2 px-3',
              isHovering ? 'hover-background-item' : 'bg-secondary-800',
              {
                'width-100-percent': isMiniSidebarShown
              }
            ]"
            v-bind="itemProps(tooltipProps, hoverProps)"
            @click="item.isButton ? liveChatHandler() : null"
          >
            <v-icon size="20" class="d-block mx-auto">
              {{ item.icon }}
            </v-icon>
          </v-list-item>
        </v-hover>
      </template>
      <span>{{ item.label }}</span>
    </v-tooltip>
  </v-list>
</template>

<script>
  import { mergeProps } from 'vue'
  import { mapState } from 'pinia'
  import { useSettingsStore } from '@/store/settings/settings'

  export default {
    name: 'SupportLinks',
    computed: {
      ...mapState(useSettingsStore, ['isMiniSidebarShown', 'adNetwork']),
      socialNetworks() {
        return this.adNetwork.settings.socialNetworks.map((social) => ({
          ...social,
          isShown: true
        }))
      },
      supportMenu() {
        return [
          {
            label: this.$t('main.help'),
            url: this.adNetwork.settings.helpUrls.help,
            icon: '$question-stroke',
            isShown: !!this.adNetwork.settings.helpUrls.help
          },
          ...this.socialNetworks,
          {
            label: this.$t('main.live_chat'),
            icon: '$message',
            isButton: true,
            isShown: !!this.adNetwork.settings.liveChat.type
          }
        ].filter((item) => item.isShown)
      }
    },
    methods: {
      itemProps(tooltipProps, hoverProps) {
        return mergeProps(this.isMiniSidebarShown ? tooltipProps : {}, hoverProps)
      },
      liveChatHandler() {
        const { liveChat } = this.adNetwork.settings
        if (liveChat.type === 'intercom') {
          this.$intercom.show()
        } else if (liveChat.type === 'tawk') {
          this.$tawk.toggleChat()
        } else if (liveChat.type === 'dashly') {
          this.$dashly.openChat()
        } else if (liveChat.type === 'crisp') {
          this.$crisp.toggleChat()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .min-height-auto {
    min-height: auto;
  }

  .flex-unset {
    flex: unset;
  }

  .hover-background-item {
    background-color: color-mix(in srgb, rgb(var(--v-theme-secondary-800)) 60%, transparent);
  }

  :deep(.v-list-item__overlay) {
    display: none;
  }

  .custom-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
  .gap-4 {
    gap: 4px;
  }
  .width-100-percent {
    width: 100%;
  }
</style>
